import React from 'react';
import { motion } from 'framer-motion';
import { useAnalytics } from '../contexts/AnalyticsContext';

const TrafficSources = () => {
  const { analyticsData } = useAnalytics();

  const getTrafficSources = () => {
    const sources = {};
    
    analyticsData.pageViews.forEach(pv => {
      const source = pv.referrer || 'Direct';
      if (!sources[source]) {
        sources[source] = 0;
      }
      sources[source]++;
    });

    const total = Object.values(sources).reduce((sum, count) => sum + count, 0);
    
    return Object.entries(sources)
      .map(([source, count]) => ({
        source,
        count,
        percentage: total > 0 ? (count / total) * 100 : 0
      }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 5);
  };

  const trafficSources = getTrafficSources();

  const getSourceColor = (index) => {
    const colors = [
      'bg-blue-500',
      'bg-green-500',
      'bg-purple-500',
      'bg-yellow-500',
      'bg-red-500'
    ];
    return colors[index % colors.length];
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-6">Traffic Sources</h3>
      
      <div className="space-y-4">
        {trafficSources.length === 0 ? (
          <p className="text-gray-500 text-center py-8">No traffic data available</p>
        ) : (
          trafficSources.map((source, index) => (
            <motion.div
              key={source.source}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center justify-between"
            >
              <div className="flex items-center flex-1">
                <div className={`w-3 h-3 rounded-full mr-3 ${getSourceColor(index)}`}></div>
                <span className="text-sm font-medium text-gray-900 truncate">
                  {source.source}
                </span>
              </div>
              <div className="text-right ml-4">
                <p className="text-sm font-semibold text-gray-900">
                  {source.percentage.toFixed(1)}%
                </p>
                <p className="text-xs text-gray-500">
                  {source.count} visits
                </p>
              </div>
            </motion.div>
          ))
        )}
      </div>
    </div>
  );
};

export default TrafficSources;